import { type CreateAdminModel } from '@/shared/api'
import { type FieldLength } from '@/shared/lib/form-utils'

export const FIELD_LENGTH: {
  [key in keyof Required<
    Pick<CreateAdminModel, 'login' | 'password'>
  >]: FieldLength
} = {
  login: {
    minLength: 4,
    maxLength: 25,
  },
  password: {
    minLength: 4,
    maxLength: 25,
  },
}
